<template>
  <div class="w-100 m-0 d-flex justify-content-center">
        <div class="container-inputs p-3 m-0">
            <Breadcrumbs :breadcrumbs="breadcrumbs"/>
            <h1 class="display-4 text-white fw-normal title">Deelname stopzetten</h1>
            <div style="display: none;" id="info" class="w-100 mt-2">
            <p class="rounded-2 text-start small text-dark bg-info w-100 ao-info position-relative p-3">
                    <i class="fa fa-question-circle me-1"></i> Je kunt je huidige deelname(s) zelf stopzetten. Deze kun je stopzetten vanaf <b>{{ $formatDate(dynamic.change_at) }}</b>.  Je kunt zelf aangeven wanneer je van plan bent je deelname te beëindigen. Kies hiervoor een datum in het onderstaande veld.
            </p>
          </div>
          <div id="requestEndAt" class="w-100" style="display: none">
            <p class="bg-warning p-3 rounded-2 small text-dark">
                <i class="fa fa-exclamation me-1"></i> Je hebt aangegeven je deelname stop te willen zetten. Deze wordt stopgezet op <b id="endsAt">{{ customer.request_end_at ? $formatDate(customer.request_end_at) : '' }}</b>. Je ontvangt van ons een e-mail zodra we je deelname volledig stopgezet hebben.
            </p>
        </div>

        <!-- Kies een datum -->
        <div class="w-100" id="customerRequestEndAt" v-if="!customer.request_end_at">
            <div class="row row-cols-1 row-cols-md-2 position-relative">
                <div class="col mb-4">
                    <label for="currentPassword" class="text-white fw-bold mt-2">Datum stopzetten</label>
                </div>
                <div class="col mb-4">
                    <select class="form-select" id="request_end_at" v-model="request_end_at">
                        <option v-for="(date) in changeAtOptions" :key="date" :value="date">
                            {{ displayStartDate(date) }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="clearfix">
            <div id="endParticipations" class="w-100" style="display: none;">
                <router-link :to="isKnab ? '/products-crowdsurance' : '/products'" class="btn btn-light"><i class="fa fa-arrow-left"></i> Terug naar {{ isKnab ? 'Mijn crowdsurance' : 'producten' }}</router-link>
                <a class="btn btn-danger float-end" id="endButton" v-if="!customer.request_end_at" @click="endParticipations()"><i class="fa fa-stop-circle"></i> Ja, ik wil stoppen</a>
            </div>
        </div>
    </div>
  </div>

  <Modal v-for="modal in modals" :key="modal.title" :title="modal.title" :content="modal.content"
        :button_text="modal.button_text" :button_icon="modal.button_icon" :url="modal.url" :modal_type="modal.modal_type" :question_enum="modal.question_enum" :additional_class="modal.additional_class"
        @closeModal="closeModal" @endParticipationCallback="endParticipationCallback" />
</template>

<script type="text/javascript">
import Breadcrumbs from '@/components/BreadcrumbsComponent.vue';
import Modal from '@/components/ModalComponent.vue';
import { Breadcrumb, setCustomer, updateAppearanceKnab, isKnab  } from '@/App.vue';
import $ from 'jquery';

export default {
  name: 'LoginPage',
  components: {
      Breadcrumbs,
      Modal,
  },
  data() {
    return {
      breadcrumbs: [new Breadcrumb('/products', 'Mijn producten'), new Breadcrumb('/products/stop', 'Deelname stopzetten')],
      dynamic: {},
      modals: [],
      customer: {},
      isKnab: isKnab(),
      request_end_at: 0,
      changeAtOptions: [],
    }
  },
  methods: {
    displayStartDate(date) {
        let d = new Date(date);
        let months = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
        
        return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    },
    endParticipations() {
        this.modals.push(this.$createModal("Weet je zeker dat je je huidige deelname wilt beëindigen?", "Je kunt dit niet ongedaan maken.<br/>Je deelname wordt stopgezet op <b>" + (this.request_end_at ? this.$formatDate(this.request_end_at) : '') + "</b>.<br/>", "fa-check", "Beëindig mijn deelname", "/", this.$ModalType.HighImportanceQuestion, "endParticipationCallback"));
      },
      endParticipationCallback() {
        try {
              this.$http.post('stop_customer_participations/', {
                    responseType: 'application/json',
                    withCredentials: true,
                    request_end_at: this.request_end_at,
                    change_at: this.dynamic.change_at,
                })
              .then(async (response) => {
                  let data = response.data;
                  if(data.success) {
                      $("#endButton").addClass('disabled').attr('disabled', 'disabled');
                      $(".close").trigger('click');
                      $("#requestEndAt").show('slow');

                      const customer = await this.$http.get('/my');
                      if (customer) {
                        let customerData = (customer.data);
                        $("#endsAt").text(this.$formatDate(customerData.request_end_at));
                        setCustomer(customerData);
                        
                        $("#customerRequestEndAt").hide('slow');
                        $("#endButton").hide('slow');

                        if(this.customer.request_end_at) {
                            $("#info").hide('slow');
                            $("#endParticipations").hide('slow');
                            $("#requestEndAt").show('slow');
                        }
                      }
                  } else {
                      $(".close").trigger('click');
                      setTimeout(() => {
                          this.modals.push(this.$createModal("Er is iets misgegaan.", data.reason, "fa-check", "OK", "/", this.$ModalType.Notification, "endParticipationCallback"));
                      }, 800);
                  }
              })
          } catch (error) {
              console.error(error.response?.data?.errors);
              console.error(error);
          }
      },
      closeModal() {
          this.modals[0].additional_class = 'disappear';
          setTimeout(() => {
              this.modals = [];
          }, 500);
      },
  },
  async mounted() {
    if(isKnab()) {
        updateAppearanceKnab();
    }

    if(this.isKnab) {
        this.breadcrumbs = [new Breadcrumb('/products-crowdsurance', 'Mijn crowdsurance'), new Breadcrumb('/products/stop', 'Deelname stopzetten')]
    }

    const response = await this.$http.get('/participants/dynamic');
    this.dynamic = response.data;

    // Zet standaard datum
    this.request_end_at = +(new Date(this.dynamic.change_at));

    let minDate = this.dynamic.change_at;
    $("#request_end_at").on('change', function() {
        let dateVal = $("#request_end_at").val();
        if(new Date(dateVal) < new Date(minDate) || new Date(dateVal).getDate() > 23) {
            $("#endButton").addClass('disabled');
            $("#endButton").attr('disabled', 'disabled');
        } else {
            $("#endButton").removeClass('disabled');
            $("#endButton").removeAttr('disabled');
        }
    });
    
    let customerData;

    const customer = await this.$http.get('/my');
    if (customer) {
        customerData = (customer.data);
        $("#endsAt").text(this.$formatDate(this.dynamic.change_at));
        setCustomer(customerData);
    }

    if(!customerData) {
        console.log("Customer not found");
        return;
    }
    this.customer = customerData;
    
    if(!this.customer.request_end_at) {
        $("#info").show('slow');
        $("#endParticipations").show('slow');
    } else {
        $("#requestEndAt").show('slow');
    }
    
    $("#endParticipations").show('slow');

    this.now = new Date(new Date().setHours(0,0,0,0));

    // STAP 1 breakpoinst bepalen
    this.changes = [this.now];
    this.dynamic.participants.forEach(function(participant) {
        const start_at = new Date(participant.start_at),
            end_at = participant.end_at ? new Date(participant.end_at) : null;

        // opv start, in toekomst, of niet lege end
        if(start_at > this.now) {
            let change = new Date(start_at);
            if(this.changes.map(Number).indexOf(+change) == -1) {
                this.changes.push(change);
            }
        }
        if(end_at) {
            let change = new Date(end_at);
            change.setDate(change.getDate() + 1);

            if(this.changes.map(Number).indexOf(+change) == -1) {
                this.changes.push(change);
            }
        }
    }.bind(this));
        // Data toevoegen
        for(let i = 0; i < 4; i++) {
            let date = new Date(this.dynamic.change_at);
            date.setMonth(date.getMonth() + i)
            this.changeAtOptions.push(+date);
        }
    }
}
</script>
